<template>
  <section>
    <div v-if="frenteCaixa.cxData <= hoje">
      <AberturaFrenteDeCaixa v-if="validaCaixa() && 
        frenteCaixa.caixa.aberto != 1" />
      <ModalReaberturaCaixa v-if="!validaCaixa() && 
        frenteCaixa.caixa.aberto != 1" />
      <div class="d-flex">
        <table-pendentes :prop-pedidos-fc="frenteCaixa.pedidos"
                         class="col-9 mr-3" />
        <sid-bar-pendentes class="col-3 mt-3" />
      </div>
    </div>
    <div v-if="frenteCaixa.cxData > hoje">
      <span>Não é possivel acessar caixas futuros</span>
    </div>
  </section>
</template>

<script>
  import { mapState } from "vuex"
  import TablePendentes from "./TablePendentes"
  import SidBarPendentes from "./SidBarPendentes"
  import AberturaFrenteDeCaixa from "../Abertura/AberturaFrenteDeCaixa.vue"
  import ModalReaberturaCaixa from "../Abertura/ModalReaberturaCaixa.vue"
  import moment from "moment"

  export default ({
    name: 'FrenteDeCaixaPendetes',
    components: {
      TablePendentes,
      SidBarPendentes,
      AberturaFrenteDeCaixa,
      ModalReaberturaCaixa
    },
    data () {
      return {
        pedidos: null,
        hoje: moment().format('YYYY-MM-DD')
      }
    },
    computed: mapState(['frenteCaixa']),
    methods: {
      validaCaixa () {
        if (this.frenteCaixa.cxData === this.hoje) return true
        return false
      }
    }
  })
</script>

<style scoped>

</style>
